import React from 'react';

interface Props extends React.HTMLAttributes<HTMLElement> {
    level: 1 | 2 | 3 | 4 | 5 | 6;
    children: React.ReactNode;
    bold?: boolean;
    'data-testid'?: string;
    'data-i18n-key'?: string;
    // Forwarded for Automate's inspector, like data-i18n-key (see Button).
    'data-rs-setting-dynamic'?: string;
}

function Header({
    level,
    children,
    bold,
    className,
    'data-testid': dataTestId,
    'data-i18n-key': dataI18nKey,
    'data-rs-setting-dynamic': dataRsSettingDynamic,
}: Props) {
    const classNames = `${className || ''} header-${level} ${bold ? 'bold' : ''}`;

    return (
        <div
            className={classNames}
            data-testid={dataTestId}
            data-i18n-key={dataI18nKey}
            data-rs-setting-dynamic={dataRsSettingDynamic}
        >
            {children}
        </div>
    );
}

export default Header;
